import { render } from "./FeedbackButton.vue?vue&type=template&id=37a8c769&scoped=true&ts=true"
import script from "./FeedbackButton.vue?vue&type=script&lang=ts"
export * from "./FeedbackButton.vue?vue&type=script&lang=ts"

import "./FeedbackButton.vue?vue&type=style&index=0&id=37a8c769&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a8c769"]])

export default __exports__